<mat-card id="{{news.Id}}" class="newsElementItem row">
  <mat-card-header class="headline">{{news.Title}}</mat-card-header>
  <mat-card-subtitle class="newsSubtitle subhead strong">{{news.Published | date: 'dd.MM.yyyy'}}</mat-card-subtitle>
  <img class="newsImage" src="../../../assets/images/quote.png" alt="newsImage"/>
  <mat-card-content class="newsContent" [innerHTML]="safeHtml"></mat-card-content>
</mat-card>
